import { useState } from "react";
import { Storage } from "aws-amplify";
import { Stack, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { gql, useReactiveVar } from "@apollo/client";
import {
  materialByMPN,
  materialEntityRelationByCode,
  offerByNumber,
} from "../query";

import createQuote from "../../pricing/onCreate";
import { userEntityRelationVar } from "../../../../client/cache";
import { toChinaDateString } from "../../../../lib/chinaDate";


export const TemplateLabel = ({ rows }) => {
  const { entityID } = useReactiveVar(userEntityRelationVar);

  const [isLoading, setIsloading] = useState(false);
  const filename = "pricing.csv";
  const path = `${entityID}/template/${filename}`;

  return (
    <Stack
      direction="row"
      spacing={2}
      // display="flex"
      // justifyContent="center"
      alignItems="center"
      // sx={{ alignItems: "center" }}
    >
      <Typography variant="h6">Template: </Typography>
      <Typography variant="p">{filename}</Typography>

      <LoadingButton
        loading={isLoading}
        size="small"
        onClick={async () => {
          setIsloading(true);
          try {
            const fetchedURL = await Storage.get(path, {
              download: false,
              validateObjectExistence: true,
              // level: 'protected',
            });
            window.location.href = fetchedURL;

            // console.log({window})

            // const downloadFolder = window.downloads.getDownloadFolder();

            // console.log({ downloadFolder });
            // debugger;
          } catch (err) {
            console.log({ err444: err });
          }
          setIsloading(false);
        }}
        variant="contained"
      >
        download
      </LoadingButton>
    </Stack>
  );
};

export const headerIdentifier = [
  // { label: "tee4", isRequired: false },
  { label: "DATE", isRequired: true },
  { label: "NUMBER", isRequired: true },
  { label: "CUSTOMERID", isRequired: true },
  { label: "CUSTOMER", isRequired: false },
  { label: "MATERIALID", isRequired: false },
  { label: "MAETRIALENTITYRELATIONID", isRequired: false },
  { label: "GCAS", isRequired: true },
  { label: "MFR", isRequired: true },
  { label: "MPN", isRequired: true },
  { label: "PRICE", isRequired: true },
  { label: "CURRENCY", isRequired: true },
  { label: "UNIT", isRequired: true },
  { label: "INCOTERMS", isRequired: true },
  { label: "PAYMENTTERMS", isRequired: true },
  { label: "STATUSCODE", isRequired: true },
];

export async function onCreate({ rows, definerID, client }) {
  await Promise.all(
    rows.map(async (row) => {
      const {
        MATERIALID,
        MAETRIALENTITYRELATIONID,
        CUSTOMERID,
        SALESID,
        BUYERID,
        VENDORID,
        DATE,
        NUMBER,
        PRICE,
        CURRENCY,
        PAYMENTTERMS,
        STATUSCODE,
        INCOTERMS,
        INCOTERMENTITYUSERRELATIONID,
      } = row;
      const values = {
        date: toChinaDateString(DATE),
        materialID: MATERIALID,
        materialEntityRelationID: MAETRIALENTITYRELATIONID,

        number: NUMBER,
        itemNumber: "00010",
        salesID: SALESID,
        buyerID: BUYERID,
        vendorID: VENDORID,
        customerID: CUSTOMERID,
        definerID,
        price: PRICE,
        currency: CURRENCY,
        paymentTerms: PAYMENTTERMS,
        incoTerms: {
          terms: INCOTERMS,
          entityUserRelationID: INCOTERMENTITYUSERRELATIONID,
        },
        statusCode: STATUSCODE,
      };

      await createQuote({ client, values });
    })
  );
}

export async function validator({ rows, definerID, client }) {
  const newarr = await Promise.all(
    rows?.map(async (row) => {
      let ERROR = [];
      console.log({ row });
      const {
        GCAS,
        MPN,
        MFR,
        CUSTOMERID,
        DATE,
        NUMBER,
        PRICE,
        CURRENCY,
        UNIT,
        INCOTERMS,
        PAYMENTTERMS,
      } = row;

      if (GCAS) {
        const { data } = await client.query({
          query: gql(materialEntityRelationByCode),
          variables: { code: row.GCAS, entityID: { eq: CUSTOMERID } },
        });
        const materialEntityRelationFound =
          data?.materialEntityRelationByCode?.items?.find(
            (x) => x.material.mpn === MPN && x.material.mfr === MFR
          );

        if (!materialEntityRelationFound) {
          ERROR.push({
            attr: "GCAS",
            isMajor: true,
            msg: "GCAS and material don't match",
          });
          return { ...row, ERROR };
        }
        row.MATERIALID = materialEntityRelationFound.materialID;
        row.MAETRIALENTITYRELATIONID = materialEntityRelationFound.id;
        row.CUSTOMER =
          materialEntityRelationFound.entity.alias ||
          materialEntityRelationFound.entity.name;

        console.log({ materialEntityRelationFound });
      } else {
        const { data } = await client.query({
          query: gql(materialByMPN),
          variables: {
            mpn: MPN,
            mfr: { eq: MFR },
            filter: { definerID: { eq: definerID } },
          },
        });
        const materialsFound = data?.materialByMPN?.items;

        console.log({ materialsFound });

        if (materialsFound?.length > 1) {
          ERROR.push({
            attr: "MPN",
            isMajor: true,
            msg: "Multiple materials share the samme MPN and MFR",
          });
          return { ...row, ERROR };
        }
        const materialFound = materialsFound?.[0];

        if (!materialFound) {
          ERROR.push({
            attr: "MPN",
            isMajor: true,
            msg: "Material not found",
          });
          return { ...row, ERROR };
        }

        row.MATERIALID = materialFound.id;
        row.MAETRIALENTITYRELATIONID = null;
      }

      const { data: data2 } = await client.query({
        query: gql(offerByNumber),
        variables: { number: NUMBER, limit: 5000 },
      });

      const offersFound = data2?.offerByNumber?.items?.find(
        (x) => x.price * 1 === PRICE * 1 && x.currency === CURRENCY
      );

      console.log({ offersFound });

      if (offersFound) {
        ERROR.push({
          attr: "PRICE",
          isMajor: true,
          msg: "Offer already exists",
        });
      }

      return { ...row, ERROR };
    })
  );

  return newarr;
}
